import { StyleSheet } from 'react-native';
import { Colors } from 'react-native-paper';
import { pixelDimensions } from '../../../config/utils';

const styles = StyleSheet.create({
  buttonBack: {
    alignSelf: 'flex-end',
    paddingVertical: pixelDimensions(2),
    paddingHorizontal: pixelDimensions(6),
    marginHorizontal: pixelDimensions(4),
    marginVertical: pixelDimensions(2),
  },
  buttonReduced: {
    width: pixelDimensions(70),
  },
  card: {
    height: pixelDimensions(33),
    borderRadius: pixelDimensions(5),
  },
  container: {
    flex: 1,
    // marginHorizontal: pixelDimensions(3),
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  content: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
  textBack: {
    color: Colors.white,
    fontSize: pixelDimensions(4.5),
  },
  viewBase: {
    flex: 1,
    backgroundColor: Colors.grey300,
  },
  viewInner: {
    padding: 0,
    paddingVertical: pixelDimensions(9),
  },
});

export default styles;
